import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling } from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const PlanCountryField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.country && touched.country}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()} >
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Country <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Field
                    as={NameField}
                    id="country"
                    name="country"
                    data-walkthroughid={walkthroughIds.plans.ufCountryInput}
                    validate={value => !value ? 'Country is required' : undefined}
                    error={errors.country}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Country for this plan."
                        ariaLabel="plan-country-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlanCountryField;
